import { NgModule } from '@angular/core';
import { TrackingCmsComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        tracking: {
          module: () => import('./tracking-lazy.module').then((m) => m.TrackingLazyModule),
          cmsComponents: Object.values(TrackingCmsComponents),
        },
      },
    }),
  ],
})
export class TrackingShellModule {}
